jQuery(document).ready(function ($) {
	let menuToggleBar = document.querySelector('.m-navigation__toggle');

	if (menuToggleBar) {
		if (menuToggleBar.style.display !== 'none') {
			let menuButton = menuToggleBar.querySelector(
				'.a-navigation__toggle__button'
			);
			let menuDrawer = document.querySelector('.m-navigation--main');
			let menuClose = document.querySelector(
				'.a-navigation__toggle__close-button'
			);
			const toggleMenu = (drawer) => {
				drawer.classList.toggle('open');

				if (this.activeElement.classList.contains('open')) {
					this.activeElement.classList.remove('open');
					this.activeElement.classList.add('reverse');
				} else {
					this.activeElement.classList.toggle('open');
					this.activeElement.classList.remove('reverse');
				}
			};
			menuButton.addEventListener('click', (e) => {
				toggleMenu(menuDrawer);
			});
			// menuClose.addEventListener('click', (e) => {
			// 	toggleMenu(menuDrawer);
			// });

			/**
			 * Mobile menu functionality
			 */
			let firstLevelParents = menuDrawer.querySelectorAll(
				'.a-navigation__link--parent'
			);
			firstLevelParents.forEach((parent) => {
				let secondLevelLists = parent.querySelectorAll(
					'.m-navigation__links_list__child_list'
				);
				let titles = parent.querySelectorAll('.a-navigation__title');

				titles.forEach((title) => {
					let siblings = parent.parentNode.children;

					title.addEventListener('click', function (e) {
						for (let sibling of siblings) {
							if (sibling !== parent) {
								let siblingLists = sibling.querySelectorAll(
									'.m-navigation__links_list__child_list'
								);
								siblingLists.forEach((list) => {
									if (list.classList.contains('open')) {
										list.classList.remove('open');
									}
								});
							}
						}
						title.nextElementSibling.classList.toggle('open');
					});
				});
				secondLevelLists.forEach((list) => {
					let childLists = list.querySelectorAll('.no-link');
					for (let child of childLists) {
						child.addEventListener('click', (e) => {
							child.classList.toggle('open');
							let subList = child.querySelector(
								'.m-navigation__links_list__child_list--sublist'
							);
							subList.classList.toggle('open');
						});
					}
				});
			});
		}
	}

	//Keyboard accessibility for Menu
	const menuItems = document.querySelectorAll('.a-navigation__link--parent');
	menuItems.forEach((parentItem) => {
		parentItem.querySelector('a').addEventListener('focus', function (e) {
			if (!this.parentNode.classList.contains('open')) {
				this.parentNode.classList.add('open');
				this.setAttribute('aria-expanded', 'true');
			} else {
				this.parentNode.classList.remove('open');
				this.setAttribute('aria-expanded', 'false');
			}

			let siblings = [];
			let sibling = this.parentNode.parentNode.firstChild;

			while (sibling) {
				if (sibling.nodeType === 1 && sibling !== this.parentNode) {
					siblings.push(sibling);
				}
				sibling = sibling.nextSibling;
			}

			siblings.forEach((sibling) => {
				if (sibling.classList.contains('open')) {
					sibling.classList.remove('open');
				}
			});

			e.preventDefault();
			return false;
		});
		let sublistItems = parentItem.querySelectorAll(
			'.a-navigation__link--child'
		);
		let lastItem = sublistItems.length - 1;
		sublistItems[lastItem]
			.querySelector('a')
			.addEventListener('blur', function (e) {
				if (parentItem.classList.contains('open')) {
					parentItem.classList.remove('open');
				}
			});
	});
});
